import React from 'react';
import { Grid } from '@mui/material';
import usePublicSessionTracking from 'parent-portal/shared/PublicSessionTracking';
import { HomeHeader } from './components/HomeHeader';
import useTrackingCookies from 'parent-portal/shared/EngagementSourceTracking';
import { useHistory } from 'react-router';

export default function Home() {
    useTrackingCookies('/');
    const { usePageLoadTracking } = usePublicSessionTracking('home');
    const history = useHistory();
    usePageLoadTracking();

    function signUp() {
        history.push('/signup');
    }

    return (
        <Grid container item style={{ gap: 20, marginBottom: 40 }}>
            <HomeHeader signUp={signUp} />
        </Grid>
    );
}
